export enum ScanModeEnum {
  JustScan = 'Just Scan',
  AccessControl = 'Access Control',
  DupeCheck = 'Dupe Check',
  DupeCheckAndAccessControl = 'Dupe Check and Access Control'
}
